import { CLEAR_ALL_FORMS } from 'root/src/client/logic/form/actionIds'

export default () => ({
	type: CLEAR_ALL_FORMS,
})
